// extracted by mini-css-extract-plugin
export default {"container":"TableTwoFooter_container__TDAba","save":"TableTwoFooter_save__lDGgW","messages":"TableTwoFooter_messages__imUZn"};